import { gql } from "@apollo/client";

export const GET_RECLAMOS = gql`
query allReclamos(
    $skip: Int
    $take: Int
    $where: GestionReclamosFilterInput,
    $order: [GestionReclamosSortInput!]
) {
    allReclamos(skip: $skip, take: $take, where: $where, order: $order )
    {
        items {
            idGestionReclamo
            puedeEditar
            idEtapaReclamo
            idEstadoReclamo
            numeroReclamo
            idDelegacion
            idAreaReclamo
            fechaRegistro
            idClasificacionReclamo
            idUsuarioResponsable
            idPaciente
            idPacienteNavigation{
                nombre
                apellido
            }
            idCliente
            idEstadoReclamoNavigation{
                descripcion
            }
            idEtapaReclamoNavigation{
                descripcion
            }
        }
        pageInfo {
            hasNextPage
            hasPreviousPage
        }
        totalCount
    }
}`;

export const adaptReclamo = (reclamo) => {
  return {
    idGestionReclamo: reclamo?.idGestionReclamo,
    id: reclamo?.numeroReclamo,
    idDelegacion: reclamo?.idDelegacion,
    idEstadoReclamo: reclamo?.idEstadoReclamo,
    idUsuarioResponsable: reclamo?.idUsuarioResponsable,
    idArea: reclamo?.idAreaReclamo,
    fechaRegistro: reclamo?.fechaRegistro,
    idClasificacionReclamo: reclamo?.idClasificacionReclamo,
    paciente: reclamo?.idPacienteNavigation ? `${reclamo?.idPacienteNavigation?.nombre} ${reclamo?.idPacienteNavigation?.apellido}` : '-',
    financiador: reclamo?.idCliente,
    estado: reclamo?.idEstadoReclamoNavigation?.descripcion,
    idEtapaReclamo: reclamo?.idEtapaReclamo,
    etapa: reclamo?.idEtapaReclamoNavigation?.descripcion,
    puedeEditar: reclamo?.puedeEditar
  };
};

const adaptReclamosArray = (reclamosData) => {
  return structuredClone(reclamosData?.allReclamos?.items)?.
    map((reclamo) => adaptReclamo(reclamo)) || [];
};

export default adaptReclamosArray;

export const adaptReclamosParsedArray = (reclamosData) => {
  return structuredClone(reclamosData)?.
    map((reclamo) => adaptReclamo(reclamo)) || [];
};